export type Ret={
    status:number;
    info:string;
    data:any;
}
export class CommonDataAndUtil{
    static STATUS_SUCCESS=1000;
    static STATUS_FAILED=1001;
    static isSuccess(r:Ret){
        return r.status==CommonDataAndUtil.STATUS_SUCCESS;
    }
}